module.exports = __webpack_public_path__ + "static/media/5.956acc3f.png";